import {createContext, useState, useContext, useEffect} from "react";
import {useLocation} from "react-router-dom";
import {LoaderSearchImage} from "../components/Loader";

export const AuthContext = createContext('')

export const AuthProvider = ({children}) => {

    const [loading, setLoading] = useState(false)
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const customerId = atob(params.get('uuid'))
    const customerBalance = atob(params.get('balance'))

    let customerParams = {
        customer_parent: customerId,
        customer_balance: customerBalance
    };

    Object.entries(customerParams).forEach(entry => {
        const [key, value] = entry;

        if (!localStorage.getItem(key)) {
            localStorage.setItem(key, value)
        }
    });

    if(loading) return <LoaderSearchImage />

return (
        <AuthContext.Provider value={{customerId}}>
            {children}
        </AuthContext.Provider>
        )
}

export const useAuth = () => useContext(AuthContext);
